export { default } from './MediaDestacat';
